import React, { useEffect, useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import {
  InputOptionMaster,
  InputReactDatepicker,
  InputTextArea,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import {
  ListFixedAsset,
  RESET_STATE_TRANSFER_ASSET,
  urlGetGudang,
  urlAdd,
} from ".";
import {
  BASE_URL_4,
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
  TYPE_INSTANCE4,
} from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { useSelectOption } from "App/hooks";
import ListTransfer from "./ListTransfer";
import fileDownload from "js-file-download";
import { getIDunit } from "App/utils/cookies";
import { useSelector } from "react-redux";

export default function FormTransferAsset({
  formData,
  setFormData,
  classes,
  setNewData,
  listTF,
  setListTF,
}) {
  const DEFAULT_SHOW_BUTTON_DOWNLOAD = {
    label: "CETAK PDF",
    color: "warninf",
    state: false,
    disabled: false,
  };
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const [disabledPDF, setDisabledPDF] = useState(DEFAULT_SHOW_BUTTON_DOWNLOAD);
  const master = useSelector(({ master }) => master);
  const fullAkses = master.access_fa.access;

  useEffect(() => {
    if (isNull(formData.id)) {
      setListTF([]);
    }
  }, [formData.gudang_sumber_id]); // eslint-disable-line react-hooks/exhaustive-deps
  const gudang = useSelectOption(
    true,
    urlGetGudang,
    TYPE_INSTANCE4,
    "gudangId",
    "name"
  );

  const gudangSumber = useSelectOption(
    true,
    "/wmsMasterAsset/gudang/list",
    TYPE_INSTANCE4,
    "gudangId",
    "name",
    "body",
    fullAkses ? {} : isNull(getIDunit())
      ? {}
      : {
          params: {
            unit: getIDunit(),
          },
        }
  );

  const add = async () => {
    const api = await instance4.post(urlAdd, {
      ...formData,
      data_detail: listTF,
    });
    const res = await api?.data;
    if (res.status === 200) {
      defaultToastSuccess("Berhasil menambah data");
      setFormData({
        ...formData,
        id: res.id,
      });
      setNewData(res.id);
    } else {
      defaultToastError(res?.message);
    }
  };

  const update = () => {
    return instance4.post(
      defaultToastError,
      {
        ...formData,
      },
      {
        headers: {
          idhistory_transfer: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (
      isNull(formData.gudang_sumber_id) ||
      isNull(formData.gudang_tujuan_id) ||
      isNull(formData.petugas) ||
      isNull(formData.penerima)
    ) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Harap lengkapi form transfer asset terlebih dahulu!");
    } else {
      if (listTF.length === 0) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError("Harap pilih asset terlebih dahulu!");
      } else {
        if (formData.gudang_sumber_id === formData.gudang_tujuan_id) {
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          defaultToastError("Tidak dapat mentrasfer pada gudang yang sama !");
        } else {
          try {
            if (formData.id === "") {
              await add();
            } else if (formData.id !== "") {
              await update();
              defaultToastSuccess("Berhasil mengubah data");
            }
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          } catch (error) {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            defaultToastError(error?.response?.data?.message);
          }
        }
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const handleClickSelectAsset = (row) => {
    const barang = listTF;
    const checkBarang = barang.filter((e) => e.fixasset_id === row.id);
    if (checkBarang.length === 0) {
      try {
        const barang = [
          ...listTF,
          {
            id: null,
            fixasset_id: row?.id,
            name: row?.name,
            code: row?.code,
            merek: row?.merek,
            type: row?.type,
          },
        ];
        setListTF(barang);
      } catch (error) {
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      defaultToastError("Tidak dapat memilih asset yang sama !");
    }
  };

  const downloadPDF = async (id, fileName) => {
    setDisabledPDF(DISABLED_BUTTON_SUBMIT);

    try {
      const api = await instance4.get(
        `${BASE_URL_4}/wmsAsset/transfer/download-pdf-transfer/${id}`,
        {
          responseType: "blob",
        }
      );
      const name = fileName + ".pdf";
      fileDownload(api.data, name);
    } catch (error) {
      return {
        state: false,
        message: error?.response?.data?.message,
      };
    }
    setDisabledPDF(DEFAULT_SHOW_BUTTON_DOWNLOAD);
  };

  return (
    <>
      <Paper
        className={classes.paper}
        style={{
          padding: "1rem 1.5rem",
        }}>
        <Grid container spacing={3}>
          <Grid item sm={12}>
            <form onSubmit={(e) => handleSubmit(e)}>
              <Grid container spacing={2}>
                <Grid item sm={8}>
                  <Grid container spacing={2}>
                    <Grid Grid item sm={4}>
                      <InputTextMaster
                        name='id'
                        label='ID'
                        id='id'
                        readOnly={true}
                        disabled={true}
                        value={formData.id}
                        placeholder='ID'
                      />
                    </Grid>
                    <Grid item sm={4}>
                      <InputTextMaster
                        name='pemesan'
                        label='PETUGAS'
                        id='petugas'
                        value={formData.petugas}
                        placeholder='Petugas'
                        onChange={handleChange("petugas")}
                        disabled={isNull(formData.id) ? false : true}
                      />
                    </Grid>
                    <Grid item sm={4}>
                      <InputTextMaster
                        name='pemesan'
                        label='PENERIMA'
                        id='penerima'
                        value={formData.penerima}
                        placeholder='Penerima'
                        onChange={handleChange("penerima")}
                        disabled={isNull(formData.id) ? false : true}
                      />
                    </Grid>
                    <Grid item sm={4}>
                      <InputReactDatepicker
                        selected={formData.date}
                        label='TANGGAL TRANSFER'
                        handleChangeToday={(e) =>
                          setFormData({
                            ...formData,
                            date: e,
                          })
                        }
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            date: e,
                          })
                        }
                        disabled={isNull(formData.id) ? false : true}
                      />
                    </Grid>
                    <Grid item sm={4}>
                      <InputOptionMaster
                        name='gudang_sumber_id'
                        label='GUDANG SUMBER'
                        id='gudang_sumber_id'
                        withSearch={true}
                        disabled={isNull(formData.id) ? false : true}
                        data={gudangSumber}
                        value={formData.gudang_sumber_id}
                        labelValue={formData.gudang_sumber}
                        onChange={(e) => {
                          if (isNull(e)) {
                            setFormData({
                              ...formData,
                              gudang_sumber_id: null,
                              gudang_sumber: "Pilih Gudang Sumber",
                            });
                          } else {
                            setFormData({
                              ...formData,
                              gudang_sumber_id: e?.value,
                              gudang_sumber: e?.label,
                            });
                          }
                        }}
                      />
                    </Grid>
                    <Grid item sm={4}>
                      <InputOptionMaster
                        name='gudang_tujuan_id'
                        label='GUDANG TUJUAN'
                        id='gudang_tujuan_id'
                        withSearch={true}
                        data={gudang}
                        disabled={isNull(formData.id) ? false : true}
                        value={formData.gudang_tujuan_id}
                        labelValue={formData.gudang_tujuan}
                        onChange={(e) => {
                          if (isNull(e)) {
                            setFormData({
                              ...formData,
                              gudang_tujuan_id: null,
                              gudang_tujuan: "Pilih Gudang Tujuan",
                            });
                          } else {
                            setFormData({
                              ...formData,
                              gudang_tujuan_id: e?.value,
                              gudang_tujuan: e?.label,
                            });
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sm={4}>
                  <InputTextArea
                    name='remark'
                    label='CATATAN TRANSFER'
                    id='remark'
                    disabled={isNull(formData.id) ? false : true}
                    placeholder='Catatan'
                    rows={6}
                    value={formData.remark}
                    onChange={handleChange("remark")}
                  />
                </Grid>
                <Grid item sm={12}>
                  <Grid
                    container
                    direction='row'
                    justifyContent='space-between'
                    alignItems='center'>
                    <MasterButton
                      outline={true}
                      type={"button"}
                      color='danger'
                      name='Reset'
                      size='md'
                      onClick={() => {
                        setFormData(RESET_STATE_TRANSFER_ASSET);
                      }}
                    />
                    {isNull(formData.id) && (
                      <MasterButton
                        outline={false}
                        type={"submit"}
                        color={disabled.color}
                        name={disabled.label}
                        disabled={disabled.disabled}
                        size='md'
                      />
                    )}
                    {!isNull(formData.id) && (
                      <MasterButton
                        outline={false}
                        type={"button"}
                        color={disabledPDF.color}
                        name={disabledPDF.label}
                        disabled={disabledPDF.disabled}
                        size='md'
                        onClick={(e) =>
                          disabledPDF.disabled
                            ? null
                            : downloadPDF(
                                formData.id,
                                formData.gudang_sumber.replace(/\s+/g, "-") +
                                  "-KE-" +
                                  formData.gudang_tujuan.replace(/\s+/g, "-")
                              )
                        }
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Grid>
          <Grid item sm={isNull(formData.id) ? "6" : "12"}>
            <ListTransfer
              classes={classes}
              formData={formData}
              listTF={listTF}
              setListTF={setListTF}
            />
          </Grid>

          {isNull(formData.id) && (
            <Grid item sm={6}>
              <Paper
                className={classes.paper}
                style={{
                  padding: "1rem 1.5rem",
                  minHeight: "262px",
                }}>
                <ListFixedAsset clickSelectHandler={handleClickSelectAsset} />
              </Paper>
            </Grid>
          )}
        </Grid>
      </Paper>
    </>
  );
}
